"use client";

import { useMediaQuery } from "@chakra-ui/react";

const desktopCheckMQ = "(min-width: 900px)";

export function isDesktop() {
    return window.matchMedia(desktopCheckMQ).matches;
}

export function useIsDesktop() {
    const [isDesktop] = useMediaQuery(["(min-width: 900px)"], {
        ssr: false,
    }); // need to verify this
    return isDesktop;
}
